import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import './app.css';
import './css/responsive.css';
import './css/styles.css';
import './css/bootstrap-grid.css';

import { FiArrowUp } from 'react-icons/fi';

import ScrollToTop from './components/loader/ScrollToTop';
import Loader from './components/loader/Loader';
import Menu from './components/navbar/Menu';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';

import Spinner from './components/loader/Spinner';

const Home = React.lazy(() => import('./pages/Home'));

const Biography = React.lazy(() => import('./pages/Biography'));
const Museum = React.lazy(() => import('./pages/Museum'));
const Gastronomy = React.lazy(() => import('./pages/Gastronomy'));
const Calendar = React.lazy(() => import('./pages/Calendar'));
const Processions = React.lazy(() => import('./pages/Processions'));
const Praise = React.lazy(() => import('./pages/Praise'));
const Prayers = React.lazy(() => import('./pages/Prayers'));

const History = React.lazy(() => import('./pages/History'));
const Outfit = React.lazy(() => import('./pages/Outfit'));
const Music = React.lazy(() => import('./pages/Music'));

const PEMCAT = React.lazy(() => import('./pages/PEMCAT'));
const Committee = React.lazy(() => import('./pages/Committee'));
const Collaborations = React.lazy(() => import('./pages/Collaborations'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Unesco = React.lazy(() => import('./pages/Unesco'));

const NotFound = React.lazy(() => import('./components/errors/NotFound'));

function App() {
    useEffect(() => {
        setTimeout(menu, 2000);

        const btnSwitch = document.querySelector('#switch');
        let body = document.querySelector('body');
        let mode = localStorage.getItem('mode');

        if (mode === 'light' || mode === null) {
            body.classList.remove('dark');
            btnSwitch.classList.remove('active');
        } else if (mode === 'dark') {
            body.classList.add('dark');
            btnSwitch.classList.add('active');
        }

        window.addEventListener('scroll', listenToScroll);
    });

    const listenToScroll = () => {
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;

        const button = document.getElementById('top');

        if (winScroll > 200) {
            button.classList.add('show');
        } else {
            button.classList.remove('show');
        }
    };

    const menu = () => {
        let btn_menu = document.querySelector('.orb-menu-btn');
        btn_menu.addEventListener('click', function () {
            let big_menu = document.querySelectorAll(
                '.orb-menu-btn, .orb-big-menu-frame, .orb-big-menu'
            );

            big_menu.forEach((big) => {
                big.classList.toggle('orb-active');
            });

            let top_bar = document.querySelector('.orb-top-bar-frame');
            top_bar.classList.toggle('orb-menu-opened');
            setTimeout(animate_menu, 300);
        });
    };

    const animate_menu = () => {
        let show_options = document.querySelector(
            '.orb-big-menu .orb-photo-frame'
        );
        show_options.classList.toggle('orb-active');
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="wrapper">
            <Loader></Loader>
            <div id="orb-dynamic-content" className="transition-fade">
                <div className="orb-page-frame orb-blog-4">
                    <Navbar></Navbar>
                    <ScrollToTop>
                        <Routes>
                            <Route
                                exact
                                path="/"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Home />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="programa"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Calendar />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="procesiones"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Processions />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="biografia"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Biography />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="museo"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Museum />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="alabanzas"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Praise />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="oraciones"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Prayers />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="gastronomia"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Gastronomy />
                                    </React.Suspense>
                                }
                            />

                            <Route
                                exact
                                path="historia"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <History />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="vestimenta"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Outfit />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="musica"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Music />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="pemcat"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <PEMCAT />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="colaboraciones"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Collaborations />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="contactos"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Contact />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="comite"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Committee />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="unesco"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <Unesco />
                                    </React.Suspense>
                                }
                            />
                            <Route
                                exact
                                path="*"
                                element={
                                    <React.Suspense fallback={<Spinner />}>
                                        <NotFound />
                                    </React.Suspense>
                                }
                            />
                        </Routes>
                    </ScrollToTop>
                </div>
                <Menu></Menu>
                <Footer />
            </div>
            <button
                type="button"
                onClick={scrollToTop}
                className="floating-button"
                id="top"
            >
                <FiArrowUp />
            </button>
        </div>
    );
}

export default App;
